import styled from 'styled-components';

export const MessageButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  .dsc-button {
    padding: 0 3px;
  }
  strong {
    display: contents;
  }
`;
